<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { IcArrowRight } from '@xpos/icons-svg';
import { eventBus } from '@/libs/EventBus';
import { getPlatform } from '@/utils/misc';

const { t, locale } = useI18n();

const $emit = defineEmits(['change', 'update:modelValue', 'close']);
const $props = defineProps({
    modelValue: {
        type: Boolean,
    },
});

const visible = ref($props.modelValue);
const currentLocale = ref(locale.value);

// Check if mobile platform
const isMobile = computed(() => {
    return getPlatform() === 'mobile-web';
});

// Supported languages list
const languages = [
    {
        code: 'en',
        name: 'English',
        nativeName: 'English'
    },
    {
        code: 'zh',
        name: 'Chinese (Simplified)',
        nativeName: '简体中文'
    },
    {
        code: 'vi',
        name: 'Vietnamese',
        nativeName: 'Tiếng Việt'
    },
    {
        code: 'id',
        name: 'Indonesian',
        nativeName: 'Bahasa Indonesia'
    }
];

// Watch modelValue changes
watch(() => $props.modelValue, (newVal) => {
    visible.value = newVal;
    if (newVal) currentLocale.value = locale.value;
});

// Watch visible changes
watch(visible, (newVal) => {
    $emit('update:modelValue', newVal);
    if (!newVal) $emit('close');
});

// Select language
const selectLanguage = (languageCode: string) => {
    if (languageCode !== currentLocale.value) {
        eventBus.emit('localeChange', languageCode);
        currentLocale.value = languageCode;
    }
    handleClose();
};

// Close dialog
const handleClose = () => {
    $emit('change', false);
    $emit('update:modelValue', false);
    $emit('close', false);
};
</script>

<template>
    <x-dialog v-model="visible" :width="isMobile ? '90%' : '770px'" :title="t('common.selectLanguage')"
        :before-close="handleClose" @close="handleClose" :close-on-click-modal="false">
        <div class="w-[350px]">
            <div>
                <div>
                    <x-item border class="mb-[10px]" @click="selectLanguage(language.code)"
                        v-for="language in languages" :key="language.code">
                        {{ language.nativeName }}
                        <template #end>
                            <el-icon color="#3A3A3A" size="30">
                                <IcArrowRight />
                            </el-icon>
                        </template>
                    </x-item>
                </div>
            </div>
        </div>
    </x-dialog>
</template>
